'use client';

import { useEffect, useState } from 'react';

/** Cronômetro regressivo dos templates de oferta (Clean Direct Offer / Fast-Commerce Grid).
 *  Zera a cada 20 minutos — é um gatilho visual, não uma promoção real. */
export function Countdown({ minutes = 20 }: { minutes?: number }) {
  const [left, setLeft] = useState(minutes * 60);
  useEffect(() => {
    const id = setInterval(() => setLeft((s) => (s <= 1 ? minutes * 60 : s - 1)), 1000);
    return () => clearInterval(id);
  }, [minutes]);
  const m = String(Math.floor(left / 60)).padStart(2, '0');
  const s = String(left % 60).padStart(2, '0');
  return (
    <span className="font-mono font-bold tabular-nums">
      {m}:{s}
    </span>
  );
}
